import { z } from 'zod';

export type CreateTeamPayload = z.infer<typeof createTeamPayloadSchema>;

export const createTeamPayloadSchema = z.object({
  name: z.string().min(1),
});
